export default __webpack_public_path__ + "static/media/SlineItems.97e0685f.png";